export const generalAttributeOptions = {

	default: {
		priority: 0,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		requireLogin: false,
		sort: 'alphanumeric'
	},

	'shared::Context::CX_Region': {
		priority: 10,
		hidden: true,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		requireLogin: true,
		sort: 'alphanumeric'
	},
	'shared::Context::CX_Usage': {
		priority: 11,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		requireLogin: true,
		sort: 'alphanumeric'
	},
	'shared::ProductType::CX_ProductFamily': {
		priority: 12,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::ProductType::HS_HousingType': {
		priority: 13,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'listSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'custom',
		customSort: [
			'Column',
			'ColumnTwist06',
			'ColumnTwist12',
			'Bollard',
			'PoleLateral',
			'PoleTop',
			'WallRecessed',
			'WallSurface',
		]
	},


	'shared::Context::HS_LightEmission': {
		priority: 100,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::Context::HS_LightEmissionCAFilter': {
		priority: 102,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::Context::LU_Filter_LightEmission_CA': {
		priority: 104,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::Context::LU_Filter_LightEmission_Uplight': {
		priority: 106,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},

	'root::LightEngine Count': {
		priority: 108,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::EBlock_1': {
		priority: 110,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::EBlock_2': {
		priority: 112,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_1': {
		priority: 114,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_2': {
		priority: 116,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},

	'root::EBlock_1::EB_ConstantLumenTechnology': {
		priority: 118,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::EBlock_1::EB_Control': {
		priority: 120,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::EBlock_1::EB_ControlNoWire': {
		priority: 122,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::EBlock_1::EB_ControlWire': {
		priority: 124,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::EBlock_1::EB_EBlockMountingType': {
		priority: 126,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: true,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::EBlock_1::EB_ElectricalProtectionClass': {
		priority: 128,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'natural'
	},
	'root::EBlock_1::EB_Wattage': {
		priority: 130,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::EBlock_1::HS_HousingPowerConnectionPosition': {
		priority: 200,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},

	'root::EBlock_2::EB_ConstantLumenTechnology': {
		priority: 202,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::EBlock_2::EB_Control': {
		priority: 204,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::EBlock_2::EB_ControlNoWire': {
		priority: 206,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::EBlock_2::EB_ControlWire': {
		priority: 208,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::EBlock_2::EB_EBlockMountingType': {
		priority: 210,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: true,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::EBlock_2::EB_ElectricalProtectionClass': {
		priority: 212,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'natural'
	},
	'root::EBlock_2::EB_Wattage': {
		priority: 214,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::EBlock_2::HS_HousingPowerConnectionPosition': {
		priority: 216,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},

	'root::LightEngine_1::LE_ColourTemperature': {
		priority: 300,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'natural'
	},
	'root::LightEngine_1::LE_DimmingLevel': {
		priority: 302,
		hidden: true,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'comboSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'natural'
	},
	'root::LightEngine_1::LE_LightDistribution': {
		priority: 304,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_1::LE_LightEmission_CA': {
		priority: 306,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_1::LE_LightEmission_Uplight': {
		priority: 308,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_1::LE_LightEmissionCA': {
		priority: 310,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_1::LE_LightEngineModuleSize': {
		priority: 312,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: true,
		unit: null,
		sort: 'natural'
	},
	'root::LightEngine_1::LE_LuminousFlux': {
		priority: 314,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_1::LE_OpticalVersion': {
		priority: 316,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_1::LE_ReflectorColour': {
		priority: 318,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'colorSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_1::LE_UpLight': {
		priority: 320,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},

	'root::LightEngine_2::LE_ColourTemperature': {
		priority: 322,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'natural'
	},
	'root::LightEngine_2::LE_DimmingLevel': {
		priority: 324,
		hidden: true,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'comboSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'natural'
	},
	'root::LightEngine_2::LE_LightDistribution': {
		priority: 326,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_2::LE_LightEmission_CA': {
		priority: 328,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_2::LE_LightEmission_Uplight': {
		priority: 330,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_2::LE_LightEmissionCA': {
		priority: 332,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_2::LE_LightEngineModuleSize': {
		priority: 334,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: true,
		unit: null,
		sort: 'natural'
	},
	'root::LightEngine_2::LE_LuminousFlux': {
		priority: 336,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_2::LE_OpticalVersion': {
		priority: 338,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_2::LE_ReflectorColour': {
		priority: 340,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'colorSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine_2::LE_UpLight': {
		priority: 342,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},

	'shared::ColourCoating::HS_ColourPriceCategory': {
		priority: 400,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::ColourCoating::HS_HousingCoating': {
		priority: 402,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::ColourCoating::HS_HousingColour': {
		priority: 404,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'colorSelect',
		hideDisabledValues: true,
		unit: null,
		sort: 'custom',
		customSort: [
			'StandardColourOfChoice',
			'Custom',
			'SeluxGraphite',
			'BlackMattTiger059',
			'SandMat',
			'ClayMat',
			'ConcreteGrayMat',
			'JetBlackRAL9005',
			'AnthraciteGreyRAL7016',
			'GraphiteGreyRAL7024',
			'IronGreyRAL7011',
			'GreyAluminiumRAL9007',
			'WhiteAluminiumRAL9006',
			'PureWhiteRAL9010',
			'TrafficWhiteRAL9016',
			'PineGreenRAL6009',
			'MossGreenRAL6005',
			'SapphireBlueRAL5003',
			'WineRedRAL3005',
			'PearledDarkGreyDB703',
			'PearledSilverGreyDB702',
			'WhiteAluminiumPerlDB701',
		]
	},
	'shared::HousingLuminaire::HS_HousingConnection': {
		priority: 500,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::HousingLuminaire::HS_HousingHeight': {
		priority: 502,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::HousingLuminaire::HS_HousingPowerConnection': {
		priority: 504,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::HousingLuminaire::HS_HousingShape': {
		priority: 506,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},

	'shared::PoleBasic::HS_Base': {
		priority: 600,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'listSelect',
		hideDisabledValues: true,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::PoleBasic::HS_Height': {
		priority: 602,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: true,
		unit: null,
		sort: 'natural'
	},
	'shared::PoleBasic::HS_NumberPoleDoors': {
		priority: 604,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'natural'
	},

	'shared::PoleSpecialLine::HS_Construction': {
		priority: 700,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'listSelect',
		hideDisabledValues: true,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::PoleSpecialLine::HS_HousingMountingLocationEblock_1': {
		priority: 702,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::PoleSpecialLine::HS_HousingMountingLocationEblock_2': {
		priority: 704,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},

	'shared::Zhaga::HS_HousingZhaga': {
		priority: 800,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
};
